import type { OrganizationMemberRole } from 'src/api/main'

/**
 * The role worth naming for a member: the workspace one, which carries no
 * application. App-scoped grants belong to their own app and say nothing about
 * standing in the workspace, so a member holding only those falls back to the
 * tier reported by `role`.
 */
export const resolveNamedMemberRole = (
  roles: ReadonlyArray<OrganizationMemberRole>
): OrganizationMemberRole | undefined =>
  roles.find((role) => role.application === null)
